import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Input, Search, Button, Icon, Segment, Form as FormUi, Dropdown, Grid } from "semantic-ui-react";
import { translate } from "react-i18next";
import Spinner from 'react-bootstrap/Spinner';
import { connect } from "react-redux";
import MultiSelect from "react-multi-select-component";
import DatePicker from "react-datepicker";
import { Field as Fieldmik } from "formik";
import Axios from 'axios';
import APP_CONSTANTS from '../../config/constants';
import SearchDropdown from "./searchDropdown";

import ReadAxios from "../../components/axiosComponent/read";
import BookingImportFile from './bookingImportModal';
import BookingImportLogs from './bookingImportLogs';

const RequestsHeader = (props) => {
  const { t } = props;

  useEffect(() => {
    console.log("props.loading", props)
    getBranch();
    getLoadType();
  }, [props.isLoading])


  let [clickedElement, setClickedElement] = useState();
  const [showFilterDiv, setshowFilterDiv] = useState(false)


  const getBranch = () => {
    ReadAxios({ baseURL: `${APP_CONSTANTS.BASE_URL}`, url: `masters/branch` })
      .then((response => {
        let options = [];
        if (response.data.resultSet && response.data.resultSet.length > 0) {
          options = response.data.resultSet.map((object, index) => {
            let temp = {}
            temp.key = object.branchCode
            temp.text = object.branchName
            temp.value = object.branchId
            temp.extra = object
            return options[index] = temp
          })
          setBranchOptions(options)
        }
      }))
      .catch(error => console.log(error))
  }

  const getLoadType = () => {
    ReadAxios({ completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/masters/load/type`, readItems: { searchTerm: ' ' } })
      .then((result) => {
        let loadTypeOptions = [];
        let loadType = [];

        let loadtypeRes = result.data.data

        if (localStorage.getItem('customerNumber') == 549) {
          loadtypeRes.forEach(element => {
            if (element.load_type_name == "Frozen") {
              element.load_type_name = 'Reefer'
            }
          });
          let newLoadType = loadtypeRes.filter((type) => {
            if (type.load_type_name == "Reefer" || type.load_type_name == "Dry") {
              return type
            }
          })

          loadType = newLoadType;
        }
        else {
          loadType = loadtypeRes;
        }

        loadTypeOptions = loadType.map((object, index) => {
          let temp = {};
          temp.key = object.load_type_id;
          temp.text = object.load_type_name;
          temp.value = object.load_type_id;
          temp.raw = { ...object };
          return (loadTypeOptions[index] = temp);
        });
        setLoadTypeOptions(loadTypeOptions)
      })
      .catch((error) => console.log(error));
  }

  const handleBillingBranchSearch = (e, data) => {
    if (data.searchQuery.length >= 2) {
      let searchTerm = data.searchQuery;
      ReadAxios({
        completeURL: `${process.env.REACT_APP_MASTER_API}/billing_party`,
      }).then((result) => {
        handleBillingPartyBranch(result.data.resultSet)
      });
    }
  }
  let handleBillingPartyBranch = (billingPartyList) => {
    let temparray = localStorage.getItem("billingpartIds");

    if (temparray != "") {
      let temp = temparray.split(",");

      let tempa = [];
      for (let index = 0; index < billingPartyList.length; index++) {
        for (let indexj = 0; indexj < temp.length; indexj++) {
          if (billingPartyList[index].billingPartyId == +temp[indexj]) {
            tempa.push(billingPartyList[index]);
          }
        }
      }
      getBillingPartyOptions(tempa)
    } else {
      getBillingPartyOptions(billingPartyList)
    }
  }
  let getBillingPartyOptions = (data) => {
    let tempBillingParty = data;
    let listOption = [];
    if (tempBillingParty.length > 0) {
      listOption = tempBillingParty.map((object, index) => {
        let temp = {};
        temp.key = object.billingPartyId;
        temp.text = object.billingPartyName;
        temp.value = object.billingPartyId;
        return (listOption[index] = temp);
      });

      setBillingParty(listOption);
    }
  }

  const getVehicleTypeSelected = (result) => {
    setVehicleType(result.raw.vehicleTypeId)
  }

  /* FILTER VARIABLE START */
  const [statusSelected, setstatusSelected] = useState([]);
  const [pickupOn, setPickupOn] = useState();
  const [bookingNo, setBookingNo] = useState();
  const [branchOptions, setBranchOptions] = useState();
  const [branchSelected, setBranchSelected] = useState();
  const [loadTypeOptions, setLoadTypeOptions] = useState();
  const [loadTypeSelected, setLoadTypeSelected] = useState();
  const [billingParty, setBillingParty] = useState();
  const [billingBranchSelected, setBillingBranchSelected] = useState();
  const [vehicleType, setVehicleType] = useState();
  const [newStatus, setNewStatus] = useState()
  /* FILTER VARIABLE ENDS */

  const getMasterBranchSelected = (branchCode, branchData) => {
    setBranchSelected(branchCode)
  }

  const checkedHeader = (event, data) => {
    removeBackgoundButton();
    event.target.classList.remove("w3-white");
    event.target.classList.add("w3-blue");
    props.onTabChangeMovementType(data.value);
  };
  const removeBackgoundButton = () => {
    let list = document.getElementsByClassName("button-group-mt");
    for (let i = 0; i < list.length; i++) {
      list[i].classList.remove("w3-blue");
      list[i].classList.add("w3-white");
    }
  };
  const handleSearch = (e) => {
    props.handleSearchChange(e.target.value)
  }

  const handleFilter = () => {
    setshowFilterDiv(!showFilterDiv)
  }

  let handleStatusFilterChange = (data) => {
    let temparry = [];
    data.map((item, index) => {
      temparry.push(item.value)
      setNewStatus(item.value)
    })
    setstatusSelected(data)
  }

  let searchCall = () => {
    let queryString = ""
    if (statusSelected && statusSelected.length > 0) {
      let statusToUpper = statusSelected.map(function (x) { return x.value.toUpperCase(); })
      let statusToString = statusToUpper.toString();
      queryString += '&status=' + statusToString
    }
    if (pickupOn)
      queryString += '&pickup_date=' + pickupOn.getFullYear() + '-' + ('0' + (pickupOn.getMonth() + 1)).slice(-2) + '-' + ('0' + pickupOn.getDate()).slice(-2)
    if (bookingNo)
      queryString += '&booking_number=' + bookingNo
    if (branchSelected)
      queryString += '&booking_branch_id=' + branchSelected
    if (loadTypeSelected)
      queryString += '&load_type_id=' + loadTypeSelected
    if (billingBranchSelected)
      queryString += '&billing_party_id=' + billingBranchSelected
    if (vehicleType)
      queryString += '&vehicle_type_id=' + vehicleType

    queryString += '&';
    props.callSearchHandleAPI(queryString)
  }

  const [ImportModalState, setImportModalState] = useState(false);
  const [cacheLoggerData, setCacheLoggerData] = useState([])
  const handleImportOpen = () => {
    setImportModalState(true);
  };
  const handleImportClose = () => {
    setImportModalState(false);
    window.location.reload();
  };

  const handleLogdata = (data) => {
    setCacheLoggerData(data);
  };

  const [importLogModalState, setImportLogModalState] = useState(false);
  const handleImportLogOpen = () => {
    setImportLogModalState(true);
  };
  const handleImportLogClose = () => {
    setImportLogModalState(false);
    window.location.reload();
  };

  const exportData = () => {
    let data = ['booking_number', 'booking_date', 'requested_pickup_date', 'requested_delivery_date', 'status', 'booking_branch', 'source', 'destination', 'no_of_vehicles', 'pending_vehicles', 'gross_weight', 'billing_party_name', 'consignee_name', 'created_by', 'created_on', 'consignor_name']
    if (props.movementType == 'primary') {
    }
    if (props.movementType == 'import') {
      data.push('CRO_number')
      data.push('shipping_line_name')
    }
    if (props.movementType == 'export') {
      data.push('DO_number')
      data.push('shipping_line_name')
    }

    const stringifyRequest = data.toString();
    props.exportTableData(stringifyRequest, newStatus, branchSelected, pickupOn, bookingNo, loadTypeSelected, billingBranchSelected, vehicleType);
  }


  return (
    <React.Fragment>
      <div id="dispatch_bar">
        <div className="container-fluid dip_bar">
          <div className="row">
            <div className="col-sm-4">
              {/* <div className="d-flex"> */}
              {/* <label
                className="mt-2 font-weight-normal"
                style={{ marginRight: "20%" }}
              > */}
              <h2 className="page-title">
                {props.title}
              </h2>
            </div>

            <div className="col-sm-8 display-flex-justify-end">
              <div className="form-inline">
                {/* <Search
                  size="mini"
                  className="mr-1 ml-1"
                  input={{ icon: "search", iconPosition: "left" }}
                  placeholder={t("action_button.search") || "Search"}
                  onKeyUp={handleSearch}
                  showNoResults={false}
                /> */}
                <Link
                  to={props.LinkName}
                  className="grey-btn-new"
                >
                  <i className="fas fa-plus"></i>{" "}
                  {t("action_button.new") || "New"}
                </Link>

                <button
                  type="file"
                  data-toggle="modal"
                  data-target="#ImportXL"
                  // hidden={props.exportHidden}
                  onClick={() => handleImportOpen()}
                  className="grey-btn"
                >
                  {/* <img
                    src="assets/svg/import.svg"
                    alt=""
                    style={{ width: "11px" }
                    className="mr-1"
                  /> */}
                  <i class="fas fa-file-import mr-1"></i>
                  {"Import"}
                </button>

                {!props.isLoading && <button type="button" data-toggle="modal" data-target="#ExportXL"
                  onClick={() => exportData()}
                  className="grey-btn" >
                  {/* <img
                      src="assets/svg/export.svg"
                      alt=""
                      style={{ width: "11px" }}
                      className="mr-1"
                    /> */}
                  <i class="fas fa-file-export mr-1"></i>
                  {t("Export") || "Export"}
                </button>
                }

                {props.isLoading && <button type="button" data-toggle="modal" data-target="#ExportXL"
                  className="grey-btn" >
                  <Spinner variant="dark" animation="border" size="sm" />

                  {t("Export") || "Export"}</button>}


                <Button size="mini" className="grey-btn-02" onClick={handleFilter} icon>
                  <Icon name="filter" size="small" />Filter
                </Button>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-4"></div>
            <div className="col-sm-4">
              <div className="form-inline">
                <Button.Group>
                  <Button
                    type="button"
                    className="w3-round button-group-mt w3-blue mt-header-button"
                    value="primary"
                    onClick={checkedHeader}
                  >
                    {"Primary"}
                  </Button>
                  {localStorage.getItem("customerNumber") == 1375 || localStorage.getItem("customerNumber") == 503 ?
                    <Button
                      type="button"
                      className="button-group-mt w3-white mt-header-button"
                      value="secondary"
                      onClick={checkedHeader}
                    >
                      {"Secondary"}
                    </Button>
                    :
                    <>
                      <Button
                        type="button"
                        className="button-group-mt w3-white mt-header-button"
                        value="import"
                        onClick={checkedHeader}
                      >
                        {"Import"}
                      </Button>
                      <Button
                        type="button"
                        className="button-group-mt w3-white mt-header-button"
                        // style={{ marginRight: "20%" }}
                        value="export"
                        onClick={checkedHeader}
                      >
                        {"Export"}
                      </Button>
                    </>
                  }
                </Button.Group>
              </div>
            </div>
            <div className="col-sm-4"></div>
          </div>
          {showFilterDiv == true /* && (props.auth.role == "Elixir" || props.auth.role == "Administrator") */ ? (
            <>
              <Segment className="ui form tiny">
                <FormUi.Group >
                  <>
                    <FormUi.Field width={4}>
                      <label>Booking No.</label>
                      <Input type="text" placeholder=""
                        onChange={(e) => setBookingNo(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            searchCall()
                          }
                        }} />
                    </FormUi.Field>
                  </>

                  <>
                    <FormUi.Field width={4}>
                      <label>Pickup Date</label>
                      <DatePicker
                        isClearable
                        style={{ width: '100%!important' }}
                        className="form-control width-100cent"
                        dateFormat="dd/MM/yyyy"
                        selected={pickupOn}
                        onChange={(date) => setPickupOn(date)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            searchCall()
                          }
                        }} />
                    </FormUi.Field>
                  </>
                  <>
                    <FormUi.Field width={4}>
                      <label>Booking Branch</label>
                      <Dropdown
                        selection
                        search
                        onChange={(value, data) => { getMasterBranchSelected(data.value, branchOptions); }}
                        options={branchOptions}
                        {...props}
                        fluid
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            searchCall()
                          }
                        }}
                      />
                    </FormUi.Field>

                    <FormUi.Field width={4}>
                      <label> Billing Party</label>
                      <Dropdown
                        selection
                        search
                        clearable
                        style={{ width: "100%" }}
                        onChange={(value, data) => { setBillingBranchSelected(data.value); }}
                        options={billingParty}
                        onSearchChange={handleBillingBranchSearch}
                        noResultsMessage="Search for Result"
                        {...props}
                        fluid
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            searchCall()
                          }
                        }}
                      />
                    </FormUi.Field>
                  </>
                </FormUi.Group>

                <FormUi.Group>

                  <>
                    <FormUi.Field width={4}>
                      <label>Load Type</label>
                      <Dropdown
                        selection
                        clearable
                        onChange={(value, data) => { setLoadTypeSelected(data.value); }}
                        options={loadTypeOptions}
                        {...props}
                        fluid
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            searchCall()
                          }
                        }}
                      />
                    </FormUi.Field>
                  </>

                  <>
                    <FormUi.Field width={4}>
                      <label> Vehicle Type</label>
                      <SearchDropdown
                        /* disabled={mode == "view" ? true : false} */
                        valueToPass={getVehicleTypeSelected}
                        /* placeholder={values.vehicle_type_placeholder} */
                        masterRoute="vehicleTypeMaster"
                        masterRouteKey="vehicleTypeId"
                        masterRouteName="vehicleType"
                        fieldName="vehicle_type"
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            searchCall()
                          }
                        }}
                      />
                    </FormUi.Field>
                  </>

                  <>
                    <FormUi.Field width={4}>
                      <label>
                        Status</label>
                      <MultiSelect
                        //className="mr-1 checkselect"
                        className=""
                        style={{ width: '100%!important' }}
                        fluid
                        title={statusSelected}
                        //COMPLETE,INPROGRESS,CREATED,RECVD,REJECT,CANCEL,PARTIALCANCEL
                        options={[
                          { key: "1", label: "Complete", value: "COMPLETE" },
                          { key: "2", label: "In Progress", value: "INPROGRESS" },
                          { key: "3", label: "Created", value: "CREATED" },
                          { key: "4", label: "Recieved", value: "RECVD" },
                          { key: "5", label: "Rejected", value: "REJECT" },
                          { key: "6", label: "Cancel", value: "CANCEL" },
                          { key: "7", label: "Partial Cancel", value: "PARTIALCANCEL" },
                        ]}
                        value={statusSelected}
                        onChange={handleStatusFilterChange}
                        overrideStrings={{
                          "allItemsAreSelected": "All items are selected.",
                          "clearSearch": "Clear Search",
                          "noOptions": "No options",
                          "search": "Search",
                          "selectAll": t("order_status.select_all") || "Select All",
                          "selectSomeItems": t("order_status.label") || "Select Status"
                        }
                        }
                      />
                    </FormUi.Field>
                  </>
                </FormUi.Group>

                <Grid>
                  <Grid.Row centered>
                    <Grid.Column width={2}>
                      <Button className="w3-button w3-small w3-border w3-blue w3-hover-blue ml-1 w3-round" onClick={searchCall}>Search</Button>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>




              </Segment>

            </>
          ) : (null)}
        </div>
      </div>
      <>
        <BookingImportFile
          openBox={ImportModalState}
          handleClose={handleImportClose}
          fileName={props.baseURL}
          baseURL={props.baseURL}
          handleImportLogOpen={handleImportLogOpen}
          handleLogdata={handleLogdata}
        />
        <BookingImportLogs
          openBox={importLogModalState}
          handleClose={handleImportLogClose}
          dataToLog={cacheLoggerData}
        />
      </>
    </React.Fragment>
  );
};
const mapStateToProps = ({ permissions }) => {
  return {
    permissions,
  };
};
export default connect(mapStateToProps)(translate("orders")(RequestsHeader));
